module.exports = __webpack_public_path__ + "static/media/welcome.71e33ea3.png";